import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    usuario: null
  },

  mutations: {
    setUsuario(state, usuario) {
      state.usuario = usuario
    }
  },

  actions: {
    guardarUsuario({ commit }, usuario) {
      // Vuex
      commit('setUsuario', usuario)

      // Persistencia CORRECTA
      localStorage.setItem('usuario', JSON.stringify(usuario))
    },

    autoLogin({ commit }) {
      const usuarioGuardado = localStorage.getItem('usuario')

      if (usuarioGuardado) {
        try {
          commit('setUsuario', JSON.parse(usuarioGuardado))
        } catch (e) {
          localStorage.removeItem('usuario')
        }
      }
    },

    salir({ commit }) {
      commit('setUsuario', null)
      localStorage.removeItem('usuario')
      router.push({ name: 'login' })
    }
  }
})
